import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { I18n } from '@ngx-translate/i18n-polyfill';

import { ErrorModel } from '@core/api';

import { RegService } from '../../services/reg.service';
import { RequestIdService } from '../../services/request-id.service';

@Component({
  selector: 'auth-registration-phone',
  templateUrl: './registration-phone.component.html',
  styleUrls: ['./registration-phone.component.scss']
})
export class RegistrationPhoneComponent implements OnInit {
  titleText = this.i18n('Регистрация');
  btnText = this.i18n('Далее');

  errors = null;
  loading = false;

  constructor(
    private requestIdService: RequestIdService,
    private regService: RegService,
    private router: Router,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.requestIdService.reset();
  }

  submit(value) {
    this.loading = true;

    this.regService.checkPhone(value)
      .pipe(finalize(() => this.loading = false))
      .subscribe(data => {
          this.router.navigate(['/auth/registration/confirmation-code']);
        },
        (err: ErrorModel) => {
          console.log(err);
          this.errors = err;
        });
  }

}
